import React from "react";
import { Container, Grid, Typography, Box } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { Link } from "react-router-dom";
import "./StandardFooter.scss";

const StandardFooter = () => {
    return (
        <footer className="standard-footer">
            <Container maxWidth="lg">
                <Grid container spacing={4}>
                    {/* About section */}
                    <Grid item xs={12} sm={6} md={4}>
                        <Typography variant="h6" className="footer-heading">
                            About MAX Aspire
                        </Typography>
                        <Typography variant="body2" className="footer-text">
                            MAX Aspire is a new digital platform designed to connect, elevate, and
                            empower Muslim professionals, entrepreneurs, and students around the
                            world. With a focus on career growth, networking, and opportunity
                            sharing, Aspire aims to become a trusted, politically neutral space
                            where members of the global Muslim community can build meaningful
                            connections and thrive together.
                        </Typography>
                    </Grid>

                    {/* Links section */}
                    <Grid item xs={12} sm={6} md={4}>
                        <Typography variant="h6" className="footer-heading">
                            Helpful Links
                        </Typography>
                        <Box className="footer-links">
                            <Link to="/about" className="footer-link">
                                About
                            </Link>
                            <Link to="/terms-of-use" className="footer-link">
                                Terms of Use
                            </Link>
                            <Link to="/privacy-security" className="footer-link">
                                Privacy & Security
                            </Link>
                            <Link to="/help" className="footer-link">
                                Help
                            </Link>
                        </Box>
                    </Grid>

                    {/* Social section */}
                    <Grid item xs={12} sm={12} md={4}>
                        <Typography variant="h6" className="footer-heading">
                            Follow Us
                        </Typography>
                        <Box className="social-icons">
                            <a
                                href="https://x.com/max_gala"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Twitter"
                                className="social-icon"
                            >
                                <TwitterIcon />
                            </a>
                            <a
                                href="https://www.facebook.com/muslimsachievingexcellence"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Facebook"
                                className="social-icon"
                            >
                                <FacebookIcon />
                            </a>
                            <a
                                href="https://www.instagram.com/onemax.ca/"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Instagram"
                                className="social-icon"
                            >
                                <InstagramIcon />
                            </a>
                            <a
                                href="https://youtube.com/@muslimsachievingexcellence"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="YouTube"
                                className="social-icon"
                            >
                                <YouTubeIcon />
                            </a>
                            <a
                                href="https://www.linkedin.com/company/max-muslim-awards"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="LinkedIn"
                                className="social-icon"
                            >
                                <LinkedInIcon />
                            </a>
                        </Box>
                    </Grid>
                </Grid>

                {/* Copyright section */}
                <Box className="copyright">
                    <Typography variant="body2">
                        © {new Date().getFullYear()} MAX Aspire. All Rights Reserved.
                    </Typography>
                </Box>
            </Container>
        </footer>
    );
};

export default StandardFooter;
